/* eslint-disable no-unused-expressions */
import React from 'react';
import {connect} from 'react-redux';
import './CreateQuestion.css';
import {getUserProgramFromPwd, getUserRole} from '../../Helpers/utils';
import {store} from '../../Redux/Store/Store';
import * as PropertyBucket from '../../Properties/Properties.js';
import {QuestionDto} from '../Dtos/QuestionDto';
import * as actionsBlock from '../../Redux/Actions/Blocks';
import * as httpService from '../HttpService/HttpService';
import PopUp from '.././PopUp/PopUp';
import {QuestionForm} from './QuestionForm';
import {Prompt} from 'react-router-dom';

class CreateQuestion extends React.Component {

	constructor(props, size) {
		super(props);
		this.state = {
			violations: [],
			activeBlock: '',
			questionCode: '',
			questionName: '',
			showPopup: false,
			showCancelTab: false,
			classesQuestion: [],
			classesBlock: [],
			disabled: '',
			isChangeRoutePossible: true,
			isBlokckSelected: false
		};
		this.handleClosePopUp = this.handleClosePopUp.bind(this);
	}

	componentDidMount() {
		document.title = "e-Kontrole | Utwórz pytanie";
		const {fetchBlocksDataForQuestions} = this.props;
		fetchBlocksDataForQuestions();
	}

	handleClosePopUp() {
		this.setState({showPopup: false});
	}



	preventChangeRoute = (newLocation) => {
		this.setState({
			showPopup: true,
			popUp: {
				title: 'Ostrzeżenie',
				notification: PropertyBucket.getCancelMessage(),
				type: 'cancel',
				newLocationLink: newLocation.pathname,
				onCLick: this.changeRoute
			}
		});

		return false;
	};

	changeRoute = () => {
		this.setState({
			isChangeRoutePossible: true
		});

		this.state.popUp.newLocationLink && this.props.history.push(this.state.popUp.newLocationLink)
	};

	handleAlertBorder = (validated, className, newClasses, areAllFieldsPassed) => {
		if (validated) {
			let index = newClasses.indexOf('alertBorder');
			areAllFieldsPassed ? areAllFieldsPassed = true : null;
			if (index !== -1) {
				newClasses.splice(index, 1);
				this.setState({[className]: newClasses});
			}
		} else {
			areAllFieldsPassed = false;
			if (!newClasses.includes('alertBorder')) {
				newClasses.push('alertBorder');
			}
			this.setState({[className]: newClasses})
		}
		return areAllFieldsPassed;
	};

	handleSave = (values) => {
		let _this = this;
		const userRole = getUserRole(this.props.userData);

		if ((userRole === 'SA' || userRole === 'A')) {
			let questionDto = new QuestionDto();
			questionDto.question = values.questionName;
			questionDto.block = values.blocks[0];
			questionDto.active = true;

			let program = '';
            if (getUserRole(this.props.userData) === 'SA') {
                program = 'UP';
            } else {
                if (store.getState().programs.selected) {
                    program = store.getState().programs.selected.code;
                } else {
                    program = getUserProgramFromPwd(this.props.userData);
                }
            }

			questionDto.abbrev = program;
			questionDto.additional = userRole !== 'SA';

			let url = PropertyBucket.urlAddQuestion();
			let callPromise = httpService.getServiceWithSupportErrors(url, 'POST', questionDto);
			callPromise.then(

				function (message) {
					if (message.violations) {
						_this.setState({
							violations: message.violations,
						})
					} else {
						_this.setState({
							violations: [],
							questionCode: message.abbreviation,
							questionName: message.question,
							disabled: 'disabled',
							isChangeRoutePossible: true,
							showPopup: true,
							popUp: {
								title: 'Komunikat',
								notification: PropertyBucket.getCreateQuestionMessage(),
								type: 'notify',
								onClickEvent: () => _this.props.history.push('/search_question')
							}
						})
					}
				},
				function (error) {
					_this.setState({
						showPopup: true,
						popUp: {title: 'Błąd', notification: error, type: 'error'}
					})
				}
			)
		} else {
			_this.setState({
				showPopup: true,
				popUp: {title: 'Błąd', notification: 'Nie masz uprawnień do zapisu pytania.', type: 'error'}
			})
		}
	};

	renderBlockItem = (loadedBlocksData) => {
		for (let i = 0; i < loadedBlocksData.length; i++) {
			loadedBlocksData[i].blockItem = loadedBlocksData[i].blockId + '. ' + loadedBlocksData[i].name;
		}
	};

	handleChangeBlockSelected = () => {
		this.setState({isBlokckSelected: true})
	 }

	render() {

		let loadedBlocksData = store.getState().activeBlocks.activeBlocks;
		this.renderBlockItem(loadedBlocksData);
		let popUp;
		this.state.showPopup ?
			popUp = <PopUp type={this.state.popUp.type}
			               title={this.state.popUp.title}
			               notification={this.state.popUp.notification}
						   link={this.state.popUp.link ? this.state.popUp.link : null} // cannot be undefined becouse of PopUp.js implementation
						   onClickEvent={this.state.popUp.onClickEvent}
			               closePopUp={this.handleClosePopUp}
			/> : null;
		return <div id='question_create'>
			{popUp}
			<h2 className='mb-3'>Utwórz pytanie</h2>
			{this.state.isBlokckSelected && <Prompt when={this.state.isBlokckSelected} message={this.preventChangeRoute}/>}
			<QuestionForm
				blocks={loadedBlocksData}
				handleSave={this.handleSave}
				activeBlock={this.state.activeBlock}
				handleBlockSelected={this.handleChangeBlockSelected}
				questionCode={this.state.questionCode}
				questionName={this.state.questionName}
				violations={this.state.violations}
			/>
		</div>
	}
}

const mapStateToProps = (state) => {
	return state;
};


const mapDispatchToProps = (dispatch) => {
	return {
		fetchBlocksDataForQuestions: () => dispatch(actionsBlock.fetchActiveBlocksForQuestions())
	}
};

export const CreateQuestionProvider = connect(mapStateToProps, mapDispatchToProps)(CreateQuestion);
